'use strict';

import Actions from './actions';
import Alert from '../../../components/alert.jsx';
import Button from '../../../components/form/button.jsx';
import ControlGroup from '../../../components/form/control-group.jsx';
import Modal from '../../../components/modal.jsx';
import React from 'react';
import Spinner from '../../../components/form/spinner.jsx';
import PropTypes from 'prop-types';


const propTypes = {
    error: PropTypes.string,
    hasError: PropTypes.object,
    help: PropTypes.object,
    loading: PropTypes.bool,
    show: PropTypes.bool,
    title: PropTypes.string,
    sub_title: PropTypes.string,
    terms: PropTypes.string,
    accept: PropTypes.func,
    decline: PropTypes.func
};


class UserTermsOfService extends React.Component {
    constructor(props) {

        super(props);

        this.els = {};
    }

    onSubmit(event) {

        event.preventDefault();
        event.stopPropagation();

        /*
        Actions.createNew({
            name: this.state.name
        }, this.props.history);
        */
    }

    render() {

        let alert;

        if (this.props.error) {
            alert = <Alert
                type="danger"
                message={this.props.error}
            />;
        }

        const formElements = <div>
            {alert}
            <div className="tos">
                <h3 className="title text-center">{this.props.title}</h3>
                <h5 className="subtitle text-center">{this.props.sub_title}</h5>
                <div dangerouslySetInnerHTML={{ __html: this.props.terms }} ></div>
            </div>
            <ControlGroup hideLabel={true} groupClasses={{ 'text-center': true }} hideHelp={true}>
                <div className='row'>
                    <div className='col-xs-6'>
                        <Button
                            type="submit"
                            onClick={this.props.decline}
                            inputClasses={{ 'btn btn-default btn-lg tos': true }}
                            disabled={this.props.loading}>

                    Decline
                            <Spinner space="left" show={this.props.loading} />
                        </Button>
                    </div>
                    <div className='col-xs-6'>
                        <Button
                            onClick={this.props.accept}
                            type="submit"
                            inputClasses={{ 'btn btn-primary btn-lg tos': true }}
                            disabled={this.props.loading}>

                    Accept
                            <Spinner space="left" show={this.props.loading} />
                        </Button>
                    </div>
                </div>
            </ControlGroup>
        </div>;

        return (
            <Modal
                classes={['modal-wide']}
                header="Terms of Service"
                demandChoice={true}
                show={this.props.show}
                onClose={() => {}}
            >

                <form onSubmit={this.onSubmit.bind(this)}>
                    {formElements}
                </form>
            </Modal>
        );
    }
}

UserTermsOfService.propTypes = propTypes;


export default UserTermsOfService;
